export default __webpack_public_path__ + "static/media/UiArchiveActive.fe979be5.svg";